/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InputRow from './InputRow'
import Loading from './Loading'
export default class TestScores extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tests: [],
      testData: [],
      testTypeData: [],
      loading: true,
      selectedTest: [],
      checkboxTest:0,
      testCheckbox:''
    }
    this.updateDateTaken = this.updateDateTaken.bind(this)
    this.deleteDateTaken = this.deleteDateTaken.bind(this)
    this.updateScore = this.updateScore.bind(this)
    this.updateTest = this.updateTest.bind(this)
    this.updateTestType = this.updateTestType.bind(this)
    this.deleteTest = this.deleteTest.bind(this)
    this.addTest = this.addTest.bind(this)
    this.getTestTypeData = this.getTestTypeData.bind(this)
  }

  componentDidMount() {

    fetch(`${process.env.REACT_APP_API_URL}/api/AcademicTest/GetAcademicTestCodes`)
      .then(res => res.json())
      .then(async res => {
        if (res.length) {
          this.setState({ testData: res })
        }
      })
      .then(() => {
        if (this.props.testScore.tests && this.props.testScore.tests.length > 0) {
          this.props.testScore.tests.forEach((element, i) => {
            let dateTaken = ''
            if (element.dateTaken) {
              const date = new Date(element.dateTaken)
              let month = date.getMonth() + 1
              let day = date.getDate()
              let year = date.getFullYear()
              if (month < 10) {
                month = '0' + month
              }
              if (day < 10) {
                day = '0' + day
              }
              if (year < 10) {
                year = '000' + year
              } else if (year < 100) {
                year = '00' + year
              } else if (year < 1000) {
                year = '0' + year
              }
              dateTaken = year + '-' + month + '-' + day
              element.dateTaken = dateTaken
            }
          })
        }
        this.setState({
          tests: this.props.testScore.tests && this.props.testScore.tests.length > 0 ? this.props.testScore.tests : [{
            test: '',
            testType: '',
            score: '',
            dateTaken: ''
          }]
        })
      })
      .catch(err => console.log(err))

    if (this.props.testScore.tests && this.props.testScore.tests.length > 0) {
      this.props.testScore.tests.forEach(async (element, i) => {
        const data = await this.getTestTypeData(element.test, i)
        if (data === 1 && i + 1 === this.props.testScore.tests.length) {
          this.setState({ loading: false })
        }
      })
      if(this.props.testScore.tests.length ==5)
      {
        if(this.props.testScore.tests[0].test===8)
        this.setState({ checkboxTest: 8 })
        else if(this.props.testScore.tests[0].test===9)
        this.setState({ checkboxTest: 9 })
        else
        this.setState({ checkboxTest: 0 })

      }
    } else {
      this.setState({ loading: false })
    }
    
  }

  async getTestTypeData(value, index) {
    return fetch(`${process.env.REACT_APP_API_URL}/api/AcademicTest/GetTestTypeByTest?TestId=${value}`)
      .then((res) => res.json())
      .then((res) => {
        const testTypeData = Array.from(this.state.testTypeData)
        testTypeData[index] = JSON.stringify(res)
        this.setState({ testTypeData: testTypeData })
        return 1
      })
  }

  async updateTest(value, index) {
    this.getTestTypeData(value, index)
      .catch(err => console.log(err))
    const { tests } = this.state
    const newTest = Array.from(tests)
    tests.forEach((element, i) => {
      if (i === index) {
        element.test = value
        element.testType = ''
      }
    })
    this.props.collectState('TS', {
      tests: newTest
    })
    this.setState({ tests: newTest })
  }

  updateTestType(value, index) {
    const { tests } = this.state
    const newTest = Array.from(tests)
    tests.forEach((element, i) => {
      if (i === index) {
        element.testType = value
      }
    })

    this.props.collectState('TS', {
      tests: newTest
    })
    this.setState({ tests: newTest })
  }

  updateScore(value, index) {
    const { tests } = this.state
    const newTest = Array.from(tests)
    tests.forEach((element, i) => {
      if (i === index) {
        element.score = value
      }
    })
    this.props.collectState('TS', {
      tests: newTest
    })
    this.setState({ tests: newTest })
  }

  updateDateTaken(value, index) {
    const { tests } = this.state
    const newTest = Array.from(tests)
    tests.forEach((element, i) => {
      if (i === index) {
        element.dateTaken = value
      }
    })
    this.props.collectState('TS', {
      tests: newTest
    })
    this.setState({ tests: newTest })
  }

  deleteDateTaken(value, index) {
    const { tests } = this.state
    const newTest = Array.from(tests)
    tests.forEach((element, i) => {
      if (i === index) {
        element.dateTaken = ''
      }
    })
    this.props.collectState('TS', {
      tests: newTest
    })
    this.setState({ tests: newTest })
  }

  deleteTest(index) {
    const { tests } = this.state
    const newTest = []
    tests.forEach((element, i) => {
      if (i !== index) {
        newTest.push(element)
      }
    })
    this.props.collectState('TS', {
      tests: newTest
    })
    this.setState({ tests: newTest })
  }

async addTest(testId) {
    
    const { tests,testData } = this.state
    let IELTS=0
    
    if (tests.length >= 5) {
      alert('Only 5 test types can be added!')
      return
    }
    let count = 1
    const errorCheck = ['', 0, null, undefined]
    tests.forEach(element => {
      if (errorCheck.indexOf(element.test) !== -1 || errorCheck.indexOf(element.testType) !== -1 || errorCheck.indexOf(element.dateTaken) !== -1 || errorCheck.indexOf(element.score) !== -1) {
        count = 0
      }
    })
    // if (count === 1) {


      this.setState({
        tests:  [{
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })

      this.props.collectState('TS', {
        tests:  [{
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })





    this.updateTest(testId, 0)
    .then(()=>{this.updateTestType(1010, 0)})
    .then(()=> {
      this.setState({
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })
      this.props.collectState('TS', {
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })

    })
    .then(()=>{
      this.updateTest(testId, 1)
    })
    .then(()=>{this.updateTestType(1007, 1)})
    .then(()=> {
      this.setState({
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })
      this.props.collectState('TS', {
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })

    })
    .then(()=>{
      this.updateTest(testId, 2)
    })
    .then(()=>{this.updateTestType(1012, 2)})
    .then(()=> {
      this.setState({
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })
      this.props.collectState('TS', {
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })

    })
    .then(()=>{
      this.updateTest(testId, 3)
    })
    .then(()=>{this.updateTestType(1011, 3)})
    .then(()=> {
      this.setState({
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })
      this.props.collectState('TS', {
        tests: [...this.state.tests, {
          test: '',
          testType: '',
          score: '',
          dateTaken: ''
        }]
      })

    })
    .then(()=>{
      this.updateTest(testId, 4)
    })
    .then(()=>{this.updateTestType(1013, 4)})


    



    // } else {
    //   alert('Please fill all the fields of all the rows before adding new rows')
    // }
  }

  render() {
    const validationError = this.props.error
    const { tests, testData, testTypeData, loading, checkboxTest } = this.state
    
    if (loading) {
      return <Loading />
    }
    const testView = []
    tests.forEach((element, index) => {
      testView.push(
        <div className='english-profi' style={{ display: 'flex', flexDirection: 'row' }}>

          <InputRow
            value={element.test}
            data={testData}
            errMsg={validationError.length > 0 && validationError[index].test ? validationError[index].test : ''}
            name="select"
            rowName="Test"
            disabled="true"
            onChange={async (val) => {
            
              await this.updateTest(val, index)
            }}
          />
          <InputRow
            value={element.testType}
            data={element.test ? JSON.parse(testTypeData[index] || '[]') : []}
            name="select"
            errMsg={validationError.length > 0 && validationError[index].testType ? validationError[index].testType : ''}
            rowName="Type"
            disabled="true"
            onChange={(val) => {
              this.updateTestType(val, index)
            }}
          />
          <InputRow
            value={element.score}
            name="text"
            errMsg={validationError.length > 0 && validationError[index].score ? validationError[index].score : ''}
            rowName="Score"
            onChange={(val) => {
              if ((val.length) < 5 || val === '') {
                this.updateScore(val, index)
              } else { alert('Please enter 4 numbers or characters !') }
            }}
          />
          <InputRow
            value={element.dateTaken}
            errMsg={validationError.length > 0 && validationError[index].dateTaken ? validationError[index].dateTaken : ''}
            name="date"
            rowName="Date Taken"
            onChange={(val) => {
              const dateTaken = new Date(val)
              // const newTestDate = Array.from(tests)
              if (!isNaN(dateTaken.getFullYear())) {
                if (parseInt(dateTaken.getFullYear()) <= 9999) {
                  this.updateDateTaken(val, index)
                }
              } else {
                this.deleteDateTaken(val, index)
              }
            }}
          />
          {/* {index >= 1 ? <button type="button" className="save delete-icon" style={{ minWidth: 40, height: 40, alignSelf: 'center' }} onClick={() => this.deleteTest(index)}>X</button> : null} */}
        </div>
      )
    })
    return (
      <div>
        {validationError.length > 0 ? <p style={{ color: 'black' }}>You must fill all available English Proficiency Types</p> : <p> </p>}
        {/* <p>Please enter your score and upload your certificate. If you did not reserve an English exam, please visit this website <a href={`${process.env.REACT_APP_API_ENGLISH}`} target="_blank">http://google.com</a></p> */}
        <p style={{ color: 'black' }}>If you have taken any of the tests below, please fill in all of the required boxes.</p>
        <p style={{ color: 'black' }}>If you have taken your IELTS (Academic, or UKVI) /TOEFL (iBT) exam and your results are not out yet, please do not enter data in this section</p>
        <p style={{ color: 'black' }}>Note: We do not accept TOEFL My Best Scores</p>
        <div className='test-view-wrapper'>
          <div>
            <label key={8}>
              <input
                type="checkbox"
                value={'IELTS'}
                name="sources"
                 checked={checkboxTest==8?true:false}
                onChange={async (e) => {
                  if(checkboxTest==0 ){
                    this.addTest(8)
                  }else if (checkboxTest==9){
                    this.setState({
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    }, () => {
                      
                      this.addTest(8)
                    })

                    this.props.collectState('TS', {
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    })
                  }
                  else{
                    this.setState({
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    })

                    this.props.collectState('TS', {
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    })
                  } 
                  
                  
                  if(checkboxTest==0 || checkboxTest==9)
                  {
                    this.setState({checkboxTest:8})
                  }else if(checkboxTest==8){
                    this.setState({checkboxTest:0})
                  }else if(checkboxTest==9)
                  {
                    this.setState({checkboxTest:8})
                  }
                  
                 

                    /*if (e.target.value == 'IELTS') {
                      this.setState({ checkboxTest: 1 })
  
                    } else if (e.target.value == 'TOEFL') {
                      this.setState({ checkboxTest: 2 })
                    } else {
                      this.setState({ checkboxTest: 0 })
                    }*/
                  
                 
                }}
              />
              {'IELTS'}

            </label>

            <label key={9}>
              <input
                type="checkbox"
                value={'TOEFL'}
                name="sources"
                 checked={checkboxTest==9?true:false}
                onChange={(e) => {
                  if(checkboxTest==0){
                    this.addTest(9)
                    
                  }else if (checkboxTest==8){
                    
                    this.setState({
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    }, () => {
                      this.addTest(9)
                    })

                    this.props.collectState('TS', {
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    })
                    
                  }else{
                    this.setState({
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    })

                    this.props.collectState('TS', {
                      tests:  [{
                        test: '',
                        testType: '',
                        score: '',
                        dateTaken: ''
                      }]
                    })
                  }
                 
                  if(checkboxTest==0)
                  {
                    this.setState({checkboxTest:9})
                  }else if(checkboxTest==9){
                    this.setState({checkboxTest:0})
                  }else if(checkboxTest==8)
                  {
                    this.setState({checkboxTest:9})
                  }

                  /*if (e.target.value == 'IELTS') {
                    this.setState({ checkboxTest: 1 })

                  } else if (e.target.value == 'TOEFL') {
                    this.setState({ checkboxTest: 2 })
                  } else {
                    this.setState({ checkboxTest: 0 })
                  }*/
                }}
              />
              {'TOEFL'}

            </label>
          </div>
          
          {checkboxTest==9 || checkboxTest==8 ?testView:null}

        </div>

        {/* <div><button type="button" className="save bordered-btn" onClick={this.addTest} disabled={tests.length >= 8}>Add More</button></div> */}
        <div><button className="save" onClick={() => { this.props.onSave() }}>Next</button></div>

      </div>
    )
  }
}
TestScores.propTypes = {
  collectState: PropTypes.func,
  testScore: PropTypes.array,
  error: PropTypes.array,
  onSave: PropTypes.func
}
